export default __webpack_public_path__ + "static/media/contact.c3a2e7bd.svg";